import {useState}                               from 'react'
import  {OKCancel}                              from '../../lib/iprs-react-library/src/index.js';  

/* 
 * React component to show a Booking description with OKCancel
 */

const BookingDescriptionForm = ({onOK, onCancel, description}) => {
    
    const [text, setText]                   = useState(description)
    
    const handleOK = e => {
        e.preventDefault();
        onOK( text );
    }        
    
    return <>
        <textarea value={text} onChange={e=>{setText(e.target.value)}} cols='60' rows='5' ></textarea>
        <OKCancel name='confirm' onOK={handleOK} onCancel={onCancel} okText='Save' />
    </>
}

export default BookingDescriptionForm         

